import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getOrderFormContact } from "../../../http/api/MasterAPI";

const OrderFormContactSelect = ({ value, error, onChangeValue }) => {
  const [listOrderFormContactSelect, setListOrderFormContactSelect] = useState([]);

  async function getOrderFormContactSelect() {
    try {
      const response = await getOrderFormContact();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          orderFormContactCd: element.varCd,
          orderFormContactName: element.varValue1,
        }))
        .filter(
          (x) => x.orderFormContactName && x.orderFormContactName.trim() !== ""
        );
      setListOrderFormContactSelect(result);
    } catch (error) {
      console.error("Failed to fetch order form contact:", error);
    }
  }

  useEffect(() => {
    getOrderFormContactSelect();
  }, []);

  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 200 }}
        error={!isNullEmpty(error)}
        //onFocus={() => validate.handleTouch("orderFormContactCd")}
      >
        <MenuItem
          key={"orderFormContact" + 1}
          value={1}
        >
          出力する
        </MenuItem>
        <MenuItem
          key={"orderFormContact" + 2}
          value={2}
        >
          出力しない
        </MenuItem>
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{ color: "#d32f2f" ,  marginLeft: 0}}>{error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default OrderFormContactSelect;
